export const CATEGORIES = [
  { key: "all", label: "All Products" },
  { key: "gaming", label: "Gaming" },
  { key: "shopping", label: "Shopping & Retail" },
  { key: "apps", label: "App Stores" },
  { key: "streaming", label: "Streaming & Social" },
  { key: "mobile", label: "Mobile & Data" },
  { key: "dining", label: "Food & Dining" },
  { key: "travel", label: "Travel & Transport" },
  { key: "software", label: "Software & Security" },
  { key: "prepaid", label: "Prepaid & Gift" },
];

// [name, region, category]
const RAW = [
  ["Airalo", "USA", "travel"],
  ["Amazon", "KSA", "shopping"], ["Amazon", "UAE", "shopping"], ["Amazon", "USA", "shopping"],
  ["Amazon Card", "USA", "shopping"],
  ["Apex Legends", "GLOBAL", "gaming"], ["Arena Breakout", "GLOBAL", "gaming"],
  ["Bigo Live", "GLOBAL", "streaming"],
  ["Blizzard", "USA", "gaming"], ["Blizzard", "EU", "gaming"],
  ["Call of Duty Modern Warfare", "GLOBAL", "gaming"],
  ["CanvasPop", "CAD", "shopping"], ["Careem", "KSA", "travel"],
  ["Cherry Credits", "USA", "gaming"], ["Clash of Clans", "GLOBAL", "gaming"],
  ["Climbing Sand Dune", "GLOBAL", "gaming"], ["Crunchyroll Premium", "USA", "streaming"],
  ["Diablo IV | Xbox", "USA", "gaming"], ["Discord", "GLOBAL", "streaming"],
  ["Doomsday", "GLOBAL", "gaming"], ["EA Apex", "USA", "gaming"],
  ["EA FC Mobile UAE Points", "UAE", "gaming"], ["EA Gift Card EU", "EU", "gaming"],
  ["EA Gift Card US", "USA", "gaming"], ["EA Play USA", "USA", "gaming"],
  ["EA SPORTS FC 24 | Xbox", "GLOBAL", "gaming"], ["eBay", "USA", "shopping"],
  ["eGift Visa", "USA", "prepaid"], ["Fashion Queen", "GLOBAL", "gaming"],
  ["FIFA 21 KSA", "KSA", "gaming"], ["FIFA Mobile", "GLOBAL", "gaming"],
  ["Final Fantasy", "GLOBAL", "gaming"], ["Five VoIP", "UAE", "mobile"],
  ["Fortnite", "AT", "gaming"], ["Fortnite", "BE", "gaming"], ["Fortnite", "FR", "gaming"],
  ["Fortnite", "DE", "gaming"], ["Fortnite", "IE", "gaming"], ["Fortnite", "IT", "gaming"],
  ["Fortnite", "NL", "gaming"], ["Fortnite", "UK", "gaming"], ["Fortnite Card", "USA", "gaming"],
  ["Free Fire", "GLOBAL", "gaming"], ["FreeFire 2200 Diamonds", "GLOBAL", "gaming"],
  ["Friendi Voice", "KSA", "mobile"], ["Game & Grub", "USA", "dining"],
  ["Game Power 7", "UAE", "gaming"], ["GameStop", "USA", "shopping"],
  ["Google Play", "BE", "apps"], ["Google Play", "KSA", "apps"], ["Google Play", "NL", "apps"],
  ["Google Play", "ES", "apps"], ["Google Play", "UAE", "apps"], ["Google Play", "USA", "apps"],
  ["GTA Online", "GLOBAL", "gaming"], ["Guild Wars 2", "USA", "gaming"],
  ["HUAWEI Gift Card", "IQ", "apps"], ["HUAWEI Gift Card", "UAE", "apps"],
  ["Identity V", "GLOBAL", "gaming"], ["IMVU US", "USA", "streaming"],
  ["Infinite Lagrange", "GLOBAL", "gaming"], ["Infinity Kingdom Arabia", "KSA", "gaming"],
  ["Apple", "USA", "apps"], ["Apple", "AT", "apps"], ["Apple", "BE", "apps"],
  ["Apple", "CAD", "apps"], ["Apple", "FR", "apps"], ["Apple", "DE", "apps"],
  ["Apple", "IE", "apps"], ["Apple", "IT", "apps"], ["Apple", "KSA", "apps"],
  ["Apple", "NL", "apps"], ["Apple", "PT", "apps"], ["Apple", "ES", "apps"],
  ["Apple", "UAE", "apps"],
  ["JumpStart Neopets", "GLOBAL", "gaming"], ["JumpStart School of Dragons", "GLOBAL", "gaming"],
  ["Karma Koin USA", "USA", "gaming"], ["Kigso", "GLOBAL", "gaming"],
  ["KingsIsle Wizard", "GLOBAL", "gaming"], ["Knives Out", "GLOBAL", "gaming"],
  ["KT Gamez", "UAE", "gaming"],
  ["League of Legends", "UK", "gaming"], ["League of Legends", "USA", "gaming"],
  ["Lebara", "DE", "mobile"], ["Lebara", "FR", "mobile"], ["Lebara", "NL", "mobile"],
  ["Lebara", "UK", "mobile"], ["Lebara Data", "FR", "mobile"], ["Lebara Data", "KSA", "mobile"],
  ["Lebara Voice", "KSA", "mobile"], ["Likee", "USA", "streaming"],
  ["Lyca Mobile", "AT", "mobile"], ["Lyca Mobile", "BE", "mobile"], ["Lyca Mobile", "DE", "mobile"],
  ["Lyca Mobile", "FR", "mobile"], ["Lyca Mobile", "IE", "mobile"], ["Lyca Mobile", "NL", "mobile"],
  ["Madden NFL 24 Xbox", "GLOBAL", "gaming"], ["MAX Mastercard", "USA", "prepaid"],
  ["McAfee", "GCC", "software"], ["Microsoft 365 & Office", "USA", "software"],
  ["Microsoft 365 ESD", "UAE", "software"], ["Microsoft Windows 10", "KSA", "software"],
  ["Minecraft", "GLOBAL", "gaming"], ["Mobile Legends", "GLOBAL", "gaming"],
  ["Mobile Legends", "UAE/Turkey", "gaming"], ["Mobily", "KSA", "mobile"],
  ["Mobily Data", "KSA", "mobile"], ["Mortal Kombat 11", "GLOBAL", "gaming"],
  ["MU Origin 2", "GLOBAL", "gaming"], ["NBA 2K24 | Xbox", "GLOBAL", "gaming"],
  ["Neoon Games", "GLOBAL", "gaming"], ["NetDragon Universal", "USA", "gaming"],
  ["Netflix", "EU", "streaming"], ["Netflix", "KSA", "streaming"], ["Netflix", "UAE", "streaming"],
  ["Netflix", "UK", "streaming"], ["Netflix", "USA", "streaming"], ["Netflix Card", "USA", "streaming"],
  ["Nintendo", "EU", "gaming"], ["Nintendo", "PL", "gaming"], ["Nintendo", "UK", "gaming"],
  ["Nintendo eShop", "USA", "gaming"], ["Nintendo Online", "USA", "gaming"],
  ["Noon", "KSA", "shopping"], ["Noon", "UAE", "shopping"], ["NordVPN", "GLOBAL", "software"],
  ["Now Mobile Voucher", "UK", "mobile"], ["Obucks Gift Card", "GLOBAL", "prepaid"],
  ["Omantel Card", "OM", "mobile"], ["Onmyoji Arena", "USA", "gaming"],
  ["Ooredoo", "OM", "mobile"], ["Orange", "BE", "mobile"], ["Orange", "FR", "mobile"],
  ["Orange", "LU", "mobile"], ["Paysafecard", "UAE", "prepaid"],
  ["Perfect World Entertainment", "GLOBAL", "gaming"], ["PLAY DXB", "UAE", "streaming"],
  ["PSN Network", "UAE", "gaming"],
  ["PSN Store", "AUS", "gaming"], ["PSN Store", "AT", "gaming"], ["PSN Store", "BH", "gaming"],
  ["PSN Store", "BE", "gaming"], ["PSN Store", "BR", "gaming"], ["PSN Store", "FR", "gaming"],
  ["PSN Store", "DE", "gaming"], ["PSN Store", "GR", "gaming"], ["PSN Store", "HK", "gaming"],
  ["PSN Store", "IT", "gaming"], ["PSN Store", "KSA", "gaming"], ["PSN Store", "KW", "gaming"],
  ["PSN Store", "LB", "gaming"], ["PSN Store", "LU", "gaming"], ["PSN Store", "NL", "gaming"],
  ["PSN Store", "OM", "gaming"], ["PSN Store", "PL", "gaming"], ["PSN Store", "QA", "gaming"],
  ["PSN Store", "SK", "gaming"], ["PSN Store", "ES", "gaming"], ["PSN Store", "UAE", "gaming"],
  ["PSN Store", "UK", "gaming"], ["PSN Store", "USA", "gaming"],
  ["PUBG Mobile", "GLOBAL", "gaming"], ["PUBG New State", "GLOBAL", "gaming"],
  ["Razer Gold", "GLOBAL", "gaming"], ["Razer Gold", "India", "gaming"], ["Razer Gold", "USA", "gaming"],
  ["Red Bull", "KSA", "dining"],
  ["RIOT ACCESS", "BH", "gaming"], ["RIOT ACCESS", "EU", "gaming"], ["RIOT ACCESS", "KW", "gaming"],
  ["RIOT ACCESS", "Mexico", "gaming"], ["RIOT ACCESS", "UAE", "gaming"], ["RIOT ACCESS", "USA", "gaming"],
  ["Roblox", "EU", "gaming"], ["Roblox", "USA", "gaming"],
  ["Runescape", "GLOBAL", "gaming"], ["RuneScape Cards", "USA", "gaming"],
  ["Salam Mobile", "KSA", "mobile"], ["Sling", "USA", "streaming"],
  ["Spotify", "BE", "streaming"], ["Spotify", "FR", "streaming"], ["Spotify", "DE", "streaming"],
  ["Spotify", "IE", "streaming"], ["Spotify", "IT", "streaming"], ["Spotify", "NL", "streaming"],
  ["Spotify", "ALGR", "streaming"], ["Spotify", "PL", "streaming"], ["Spotify", "ES", "streaming"],
  ["Spotify", "UAE", "streaming"], ["Spotify", "UK", "streaming"], ["Spotify", "USA", "streaming"],
  ["STARZPLAY", "UAE", "streaming"], ["STARZPLAY Sports", "KSA", "streaming"],
  ["Steam", "AR", "gaming"], ["Steam", "BH", "gaming"], ["Steam", "EU", "gaming"],
  ["Steam", "HK", "gaming"], ["Steam", "GLOBAL", "gaming"], ["Steam", "KSA", "gaming"],
  ["Steam", "KW", "gaming"], ["Steam", "OM", "gaming"], ["Steam", "QA", "gaming"],
  ["Steam", "TR", "gaming"], ["Steam", "UAE", "gaming"], ["Steam", "USA", "gaming"],
  ["Steam Cards", "GLOBAL", "gaming"], ["Syma Mobile", "FR", "mobile"],
  ["Talabat", "UAE", "dining"], ["TikTok Android", "GLOBAL", "streaming"],
  ["Tinder", "GLOBAL", "streaming"], ["Tinder", "BR", "streaming"], ["Tinder", "India", "streaming"],
  ["TQ Games", "USA", "gaming"], ["Twitch", "USA", "streaming"],
  ["Valorant", "UK", "gaming"], ["Valorant", "USA", "gaming"], ["Virgin", "KSA", "mobile"],
  ["Viu", "UAE", "streaming"], ["Vodafone", "QA", "mobile"], ["Walmart", "USA", "shopping"],
  ["WolfTeam", "MENA", "gaming"], ["World of Tanks", "GLOBAL", "gaming"],
  ["World of Warships", "GLOBAL", "gaming"],
  ["Xbox", "EU", "gaming"], ["Xbox", "KSA", "gaming"], ["Xbox", "UAE", "gaming"],
  ["Xbox", "UK", "gaming"], ["Xbox", "USA", "gaming"],
  ["Xbox Game Pass Core", "EU", "gaming"], ["Xbox Game Pass Core", "UAE", "gaming"],
  ["Xbox Game Pass Core", "USA", "gaming"], ["Xbox Game Pass Ultimate", "BR", "gaming"],
  ["Xbox Game Pass Ultimate", "KSA", "gaming"], ["Xbox Game Pass Ultimate", "USA", "gaming"],
  ["Xbox Games/Add-ons", "GLOBAL", "gaming"], ["Xbox Games/Add-ons", "TR", "gaming"],
  ["Xbox Live", "GCC", "gaming"], ["Xbox Live", "USA", "gaming"],
  ["Yalla Ludo Diamond", "GLOBAL", "gaming"], ["Yalla Ludo Gold", "GLOBAL", "gaming"],
  ["Zain", "KSA", "mobile"], ["Zain", "JO", "mobile"], ["Zaman AlMoharbeen", "GLOBAL", "gaming"],
  ["Zomato", "India", "dining"], ["Swiggy", "India", "dining"],
  ["Ola", "India", "travel"], ["Uber", "India", "travel"],
  ["Myntra", "India", "shopping"], ["Ajio", "India", "shopping"], ["Tata CLiQ", "India", "shopping"],
  ["Flipkart", "India", "shopping"], ["Croma", "India", "shopping"], ["Reliance Trends", "India", "shopping"],
  ["Pantaloons", "India", "shopping"], ["Max Fashion", "India", "shopping"], ["Westside", "India", "shopping"],
  ["Lifestyle", "India", "shopping"], ["Home Centre", "India", "shopping"], ["IKEA", "India", "shopping"],
  ["Pepperfry", "India", "shopping"], ["Urban Ladder", "India", "shopping"], ["Wakefit", "India", "shopping"],
  ["Vijay Sales", "India", "shopping"], ["Titan", "India", "shopping"], ["Fastrack", "India", "shopping"],
  ["Tanishq", "India", "shopping"], ["Kalyan Jewellers", "India", "shopping"], ["Joyalukkas", "India", "shopping"],
  ["Bluestone", "India", "shopping"], ["Levi's", "India", "shopping"], ["Puma", "India", "shopping"],
  ["Skechers", "India", "shopping"], ["Nykaa", "India", "shopping"], ["Decathlon", "India", "shopping"],
  ["Hamleys", "India", "shopping"], ["FirstCry", "India", "shopping"], ["DailyObjects", "India", "shopping"],
  ["Fabindia", "India", "shopping"], ["Wildcraft", "India", "shopping"], ["Ray-Ban", "India", "shopping"],
  ["BigBasket", "India", "shopping"], ["Zepto", "India", "shopping"], ["Lulu Hypermarket", "India", "shopping"],
  ["Spar Hypermarket", "India", "shopping"], ["Spencer's", "India", "shopping"],
  ["KFC", "India", "dining"], ["Domino's", "India", "dining"], ["Pizza Hut", "India", "dining"],
  ["Subway", "India", "dining"], ["Taco Bell", "India", "dining"], ["Tata Starbucks", "India", "dining"],
  ["Café Coffee Day", "India", "dining"], ["Barbeque Nation", "India", "dining"], ["Bikanervala", "India", "dining"],
  ["MakeMyTrip", "India", "travel"], ["Yatra", "India", "travel"], ["EaseMyTrip", "India", "travel"],
  ["Air India", "India", "travel"], ["SpiceJet", "India", "travel"], ["Taj Hotels", "India", "travel"],
  ["Marriott India", "India", "travel"], ["Oberoi Hotels", "India", "travel"], ["SOTC Travel", "India", "travel"],
  ["BGMI UC Official Voucher", "India", "gaming"], ["UniPin", "India", "gaming"],
  ["Nodwin Gaming", "India", "gaming"], ["Fancode", "India", "gaming"],
  ["BookMyShow", "India", "streaming"],
];

export const CATALOG = RAW.map(([name, region, category], i) => ({
  id: i + 1,
  name,
  region,
  category,
  price: "Ask for Best Offer",
}));

export const CATEGORY_LABELS = Object.fromEntries(CATEGORIES.map((c) => [c.key, c.label]));
